<template>
  <div class="mx-2 mb-2">
    <b-row v-if="totalItems <= perPage && totalItems > 0">
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">Showing <strong>{{ formatNumber(dataMeta.to) }}</strong> entries</span>
        <span
          v-if="hasSlotContent"
          class="text-muted ml-1 mr-1"
        >-</span>
        <slot />
      </b-col>
    </b-row>
    <b-row v-if="totalItems > perPage">
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">Showing {{ formatNumber(dataMeta.from) }} to {{ formatNumber(dataMeta.to) }} of <strong>{{ formatNumber(dataMeta.of) }}</strong> entries</span>
        <span
          v-if="hasSlotContent"
          class="text-muted ml-1 mr-1"
        >-</span>
        <slot />
      </b-col>
      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import { BRow, BCol, BPagination } from 'bootstrap-vue'
import { formatNumber } from '../layouts.utils'

export default {
  components: {
    BRow,
    BCol,
    BPagination,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
    perPage: {
      type: Number,
      default: null,
    },
    totalItems: {
      type: Number,
      default: null,
    },
    localItemsCount: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      hasSlotContent: false,
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    dataMeta() {
      return {
        from:
          this.perPage * (this.currentPage - 1)
          + (this.localItemsCount ? 1 : 0),
        to: this.perPage * (this.currentPage - 1) + this.localItemsCount,
        of: this.totalItems,
      }
    },
  },
  beforeUpdate() {
    this.hasSlotContent = this.checkForSlotContent()
  },
  created() {
    this.hasSlotContent = this.checkForSlotContent()
  },
  methods: {
    checkForSlotContent() {
      const checkForContent = (hasContent, node) => hasContent || node.tag || (node.text && node.text.trim())
      return (
        this.$slots.default
        && this.$slots.default.reduce(checkForContent, false)
      )
    },
  },
  setup() {
    return {
      formatNumber,
    }
  },
}
</script>
